/**
 * Remove service workers that may cache index.html with a stale CSP nonce.
 */
export default function unregisterStaleServiceWorkers() {
  if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
    return navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach(registration => registration.unregister());
    });
  }
  return Promise.resolve();
}
